import { USER_TYPE } from "../system.js";
import { CORE_PERMISSIONS } from "./corePermissionKeys.js";
/**
 * Maps which core permissions are available to which user types
 */
export const PERMISSION_AVAILABILITY = {
    // Dashboard permissions
    [CORE_PERMISSIONS.VIEW_BOOKING_DASHBOARD]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.VIEW_SURVEY_DASHBOARD]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    // User management permissions
    [CORE_PERMISSIONS.MANAGE_ADMINISTRATORS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_MANAGERS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_ACCESS_ROLES]: [USER_TYPE.ADMIN],
    // Respondent permissions
    [CORE_PERMISSIONS.MANAGE_RESPONDENTS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.RESPONDENT_LIST]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_DOCUMENT_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_DOCUMENT_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_NOTE_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_NOTE_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_CONTACT_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.RESPONDENT_CONTACT_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.MANAGE_RESPONDENT_COMPANIES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_RESPONDENT_CONTACTS]: [USER_TYPE.ADMIN],
    // Booking permissions
    [CORE_PERMISSIONS.MANAGE_BOOKINGS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.BOOKING_READ]: [USER_TYPE.MANAGER, USER_TYPE.EXTERNAL_USER],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_CREATE_VIA_BOOKING_PAGE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_CREATE_VIA_CALENDAR]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.EVENT_CREATE_VIA_CALENDAR]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_DOCUMENT_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_DOCUMENT_WRITE]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.BOOKING_CALENDAR_READ]: [
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.MANAGE_BOOKING_COMPANIES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_CONFIRMATION_TEXT]: [USER_TYPE.ADMIN],
    // Service & location permissions
    [CORE_PERMISSIONS.MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_BOOKING_PAGE_COMPANIES]: [USER_TYPE.ADMIN],
    // Survey permissions
    [CORE_PERMISSIONS.MANAGE_SURVEY_TYPES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_SURVEY_BACKGROUNDS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.SURVEY_READ]: [USER_TYPE.MANAGER, USER_TYPE.EXTERNAL_USER],
    [CORE_PERMISSIONS.SURVEY_WRITE]: [USER_TYPE.MANAGER, USER_TYPE.EXTERNAL_USER],
    [CORE_PERMISSIONS.SURVEY_COMPLETED_SEND]: [USER_TYPE.EXTERNAL_USER],
    [CORE_PERMISSIONS.VIEW_REPORTS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.VIEW_FLAGGED_QUESTIONS]: [
        USER_TYPE.EXTERNAL_USER,
        USER_TYPE.MANAGER,
    ],
    // Recipients permissions
    [CORE_PERMISSIONS.MANAGE_RECIPIENTS]: [USER_TYPE.ADMIN],
    // Configuration permissions
    [CORE_PERMISSIONS.MANAGE_APP_CONFIGURATIONS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_API]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_BILLING]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_COMPANIES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_TEMPLATES]: [USER_TYPE.ADMIN],
    // Sales and Invoicing permissions (admin only)
    [CORE_PERMISSIONS.CONFIGURE_INVOICING_AND_PAYMENTS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_INVOICING_AND_PAYMENTS_SYSTEM_CONFIG]: [
        USER_TYPE.ADMIN,
    ],
    [CORE_PERMISSIONS.MANAGE_TAX_RATES]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_ITEMS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.MANAGE_ACTIVITY_ITEMS]: [USER_TYPE.ADMIN],
    // Manage Invoices
    [CORE_PERMISSIONS.MANAGE_INVOICES]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.VIEW_INVOICES]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.CREATE_INVOICE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.EDIT_INVOICE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.DELETE_INVOICE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.CHANGE_INVOICE_STATUS]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.EXPORT_AND_SEND_INVOICE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    // Charges and Payments permissions
    [CORE_PERMISSIONS.MANAGE_CHARGES_AND_PAYMENTS]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.PERFORM_CHARGE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.DELETE_CHARGE]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.REFUND_PAYMENT]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    [CORE_PERMISSIONS.VIEW_PAYMENT_HISTORY]: [
        USER_TYPE.ADMIN,
        USER_TYPE.MANAGER,
        USER_TYPE.EXTERNAL_USER,
    ],
    // Workflows and Automations
    [CORE_PERMISSIONS.MANAGE_WORKFLOWS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.READ_WORKFLOWS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.WRITE_WORKFLOWS]: [USER_TYPE.ADMIN],
    [CORE_PERMISSIONS.DELETE_WORKFLOWS]: [USER_TYPE.ADMIN],
};
//# sourceMappingURL=permissionRegistry.js.map